import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../api';
import AuthAside from '../components/AuthAside';
import { IconCheck } from '@tabler/icons-react';

const FIELDS = [
  { key: 'username', label: 'Kullanıcı adı', type: 'text', autoComplete: 'username' },
  { key: 'password', label: 'Şifre', type: 'password', autoComplete: 'new-password' },
  { key: 'confirm', label: 'Şifre tekrar', type: 'password', autoComplete: 'new-password' },
];

export default function Register() {
  const [form, setForm] = useState({ username: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Şifreler eşleşmiyor.'); return; }
    setLoading(true); setError('');
    try {
      await authAPI.register({ username: form.username, password: form.password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Kayıt tamamlanamadı. Bilgileri kontrol edip tekrar deneyin.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <AuthAside />

      <div className="auth-main">
        <div className="auth-card">
          <div className="auth-brand-mobile">muhasib<span>.</span></div>

          {success ? (
            <div>
              <div style={{
                width: 42, height: 42, borderRadius: 'var(--radius-lg)',
                background: 'var(--pos-tint)', border: '1px solid var(--pos-line)',
                color: 'var(--pos)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', marginBottom: 18,
              }}>
                <IconCheck size={22} strokeWidth={2.2} />
              </div>
              <h1>Kaydınız alındı</h1>
              <div className="auth-sub">
                Yönetici hesabınızı onayladığında giriş yapabilirsiniz.
              </div>
              <Link to="/login" className="btn btn-ghost auth-submit" style={{ marginTop: 0 }}>
                Giriş sayfasına dön
              </Link>
            </div>
          ) : (
            <>
              <h1>Hesap oluşturun</h1>
              <div className="auth-sub">Kayıt sonrası hesabınız yönetici onayından geçer.</div>

              <form onSubmit={handleSubmit}>
                {FIELDS.map((f, i) => (
                  <div className="auth-field" key={f.key} style={i === FIELDS.length - 1 ? { marginBottom: 20 } : undefined}>
                    <label className="field-label" htmlFor={f.key}>{f.label}</label>
                    <input
                      id={f.key}
                      type={f.type}
                      autoComplete={f.autoComplete}
                      value={form[f.key]}
                      onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                      required
                    />
                  </div>
                ))}

                {error && (
                  <div className="alert alert-error" style={{ marginBottom: 14 }} role="alert">{error}</div>
                )}

                <button type="submit" disabled={loading} className="btn btn-green auth-submit">
                  {loading ? 'Kaydediliyor…' : 'Hesap oluştur'}
                </button>
              </form>

              <div className="auth-foot">
                Hesabınız var mı? <Link to="/login">Giriş yapın</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
